import { z } from 'zod';

import {
	CardStatusV5x0,
	VisaCardStatusV3,
} from '../../../../../../api/generated/cz.partners.bank.backofficegateway.cards';
import type { PhoneSchemaParams } from '../../../../../../const/zod/phoneSchema';
import { createPhoneSchema } from '../../../../../../const/zod/phoneSchema';
import {
	EMAIL_OR_EMPTY_SCHEMA,
	UUID_SCHEMA_WITHOUT_NULL,
} from '../../../../../../const/zod/zod';

export const getClickToPayFilterFormSchema = (
	getPhoneLengthError: PhoneSchemaParams['getPhoneLengthError'] = () => '',
) => {
	const schema = z.object({
		bankCardUuid: UUID_SCHEMA_WITHOUT_NULL.optional(),
		pidUuid: UUID_SCHEMA_WITHOUT_NULL.optional(),
		visaStatus: z.array(z.enum(VisaCardStatusV3)).optional(),
		status: z.array(z.enum(CardStatusV5x0)).optional(),
		phone: createPhoneSchema({ getPhoneLengthError }).catch(undefined),
		email: EMAIL_OR_EMPTY_SCHEMA.optional().catch(''),
	});

	return schema;
};

export type ClickToPayFilterForm = z.infer<
	ReturnType<typeof getClickToPayFilterFormSchema>
>;
